import {
    GET_ALL_USERS_ADMIN,
    GET_USER_ADMIN,
    GET_BADGE,
    LOCAU_LOADING,
    ADD_USER_ADMIN
  } from "../actions/MyLocationUserAction";
  
  
  const initialState = {
    userslist: [],
    user: [],
    UserBadge: [],
    loading: false,
    add: false,
  };
  
  const UserAdmin = function(state = initialState, action) {
    switch (action.type) {
        case LOCAU_LOADING: {
          return {
            ...state,
            loading: true,
            add: false
          };
        }
        case GET_ALL_USERS_ADMIN: {
            return{
                ...state,
                userslist : [...action.data],
                user:[],
                loading: false,
                add : false,
            }
        }
        case GET_USER_ADMIN: {
          return{
              ...state,
              user : [...action.data],
              loading: false
          }
        }
        case GET_BADGE: {
          return{
              ...state,
              UserBadge : [...action.data],
              loading: false
          }
        }
        case ADD_USER_ADMIN: {
          return {
            ...state,
            user:[],
            UserBadge:[],
            add : true,
            loading: false  
          };
        }
        default: {
            return state;
          }
        }
  }
  
  export default UserAdmin;
  